module.exports = __webpack_public_path__ + "static/main-img-bg-aaeec0d0232042476e5008ee71b200db.png";